import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/ui/Header';

import UserLogin from './pages/user-login';
import UserRegistration from './pages/user-registration';
import UserDashboard from './pages/user-dashboard';
import AIAgentWorkflowHub from './pages/ai-agent-workflow-hub';
import SubscriptionManagement from './pages/subscription-management';
import BookProjectDetails from './pages/book-project-details';
import HomepageSalesLanding from './pages/homepage-sales-landing';
import LegalPagesHub from './pages/legal-pages-hub';
import PrivacyPolicy from './pages/privacy-policy';
import TermsOfService from './pages/terms-of-service';
import CookiePolicy from './pages/cookie-policy';
import GDPRCompliance from './pages/gdpr-compliance';
import HelpCenter from './pages/help-center';
import PricingPage from './pages/pricing-page';
import NotFound from './pages/NotFound';
import SimpleLogin from './pages/simple-login';
import ResetPassword from './pages/reset-password';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/user-login" replace />;
  }

  return (
    <>
      <Header />
      {children}
    </>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public routes */}
          <Route path="/" element={<HomepageSalesLanding />} />
          <Route path="/user-login" element={<UserLogin />} />
          <Route path="/simple-login" element={<SimpleLogin />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/user-registration" element={<UserRegistration />} />
          <Route path="/pricing-page" element={<PricingPage />} />
          <Route path="/legal-pages-hub" element={<LegalPagesHub />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/gdpr-compliance" element={<GDPRCompliance />} />
          <Route path="/help-center" element={<HelpCenter />} />

          {/* Protected routes */}
          <Route
            path="/user-dashboard"
            element={
              <ProtectedRoute>
                <UserDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-agent-workflow-hub"
            element={
              <ProtectedRoute>
                <AIAgentWorkflowHub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription-management"
            element={
              <ProtectedRoute>
                <SubscriptionManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/book-project-details/:projectId"
            element={
              <ProtectedRoute>
                <BookProjectDetails />
              </ProtectedRoute>
            }
          />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
